import Table from 'react-bootstrap/Table';
import { Popup } from 'react-map-gl/maplibre';
import { WA_GEOLOGY_ATTRIBUTION } from './waGeology';

function text(v) {
  const s = (v ?? '').toString().trim();
  return s === '' ? '—' : s;
}

/**
 * "What rock am I on?" popup for the WA geology base maps.
 *
 * The raster geology layers show colour but no identity, so this fills the gap:
 * click anywhere with a geology base map on and get the mapped unit back.
 */
export function createWaGeologyPopup(result, fault, lngLat, setClosed) {
  const a = result?.attributes || {};
  const rows = [
    ['Unit', text(a.unitname)],
    ['Rank', text(a.rank)],
    ['Code', text(a.code)],
    ['Rock type', text(a.rocktype1)],
    ['Parent unit', text(a.parentname)],
  ].filter(([, v]) => v !== '—');

  return (
    <Popup latitude={lngLat.lat} longitude={lngLat.lng} anchor="bottom" maxWidth="330px"
      onClose={() => setClosed(false)}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>
        {text(a.unitname) !== '—' ? a.unitname : 'Geology'}
        {result?.scale ? <span style={{ fontWeight: 400, opacity: 0.7 }}> · {result.scale}</span> : null}
      </div>

      <Table striped bordered className="mb-1">
        <tbody>
          {rows.map(([k, v]) => (<tr key={k}><td>{k}</td><td>{v}</td></tr>))}
          {fault ? (
            <tr>
              <td>Structure</td>
              <td>
                {text(fault.feature || fault.symbol)}
                {fault.name ? <> — {fault.name}</> : null}
                {fault.type ? <div style={{ fontSize: '0.8rem', opacity: 0.8 }}>{fault.type}</div> : null}
                {fault.scale ? <div style={{ fontSize: '0.75rem', opacity: 0.6 }}>GSWA {fault.scale}</div> : null}
              </td>
            </tr>
          ) : null}
        </tbody>
      </Table>

      {a.descriptn ? (
        <div style={{ fontSize: '0.8rem', marginBottom: 6 }}>{a.descriptn}</div>
      ) : null}

      <div style={{ fontSize: '0.7rem', opacity: 0.7 }}>{WA_GEOLOGY_ATTRIBUTION}</div>
    </Popup>
  );
}

export default createWaGeologyPopup;
